import CardCredentialIdentityScreen from 'features/cardManagement/screens/cardCredentialChallenge/CardCredentialIdentityScreen/CardCredentialIdentityScreen';
import React from 'react';

export default function OnboardingP2PCardCredentialIdentityPage() {
  return (
    <CardCredentialIdentityScreen
      otpPath="/onboarding/p2p/credential-challenge/[cardId]/verify-otp"
      returnPath="/onboarding/p2p/debit"
    />
  );
}
